import { createActionConst } from '../../../../utils/action.utils';

const BOARD_LIST_NAMESPACE = 'BOARD_LIST';

export const STORE_BOARD_LIST = createActionConst(BOARD_LIST_NAMESPACE, 'STORE_BOARD_LIST');
export const CLEAR_BOARD_LIST = createActionConst(BOARD_LIST_NAMESPACE, 'CLEAR_BOARD_LIST');
